import Vue from 'vue';
import { ExtendedFetchFunctionReturn } from '../../fetch/fetch';
import ResponseEnvelope from './responseEnvelope';
import ResponseInfo from './responseInfo';

export class RawServiceResponse<TData = any> {
  data: TData;

  constructor(data: TData) {
    this.data = data;
  }
}

export default class ServiceResponse<TResult = any> extends RawServiceResponse<ResponseEnvelope<TResult>> {
  isError: boolean;
  data: ResponseEnvelope<TResult>;
  info: ResponseInfo;
  raw: Partial<ExtendedFetchFunctionReturn<any>>;
  status: number | undefined;
  message: string | undefined;
  detailMessage: string | undefined;

  constructor(
    response: ExtendedFetchFunctionReturn<any> | undefined,
    isError: boolean,
    message?: string,
    detailMessage?: string,
  ) {
    super(undefined as any); // intialize
    this.raw = response ?? {};
    this.data = this.raw.data ?? { info: new ResponseInfo(), result: undefined };
    this.info = this.data.info ?? {};
    this.status = this.info.statusCode ?? this.raw.status ?? undefined;
    this.isError = this.info.isError || isError;
    this.info.isError = this.isError;

    this.message = message;
    this.message = Vue.$tAlt(this.message, this.message);

    this.detailMessage = detailMessage;
    this.detailMessage = Vue.$tAlt(this.detailMessage, this.detailMessage);

    Object.freeze(this);
  }
}
